import type z from 'zod';
import type { Ordering } from './TableState';

type TableQueryFnParams<TFilters extends z.AnyZodObject | undefined> = {
  /** undefined when exporting to CSV */
  take?: number;
  /** undefined when exporting to CSV */
  skip?: number;
  /** Filters are optional, request will return wrong response with empty [] or string */
  filters: TFilters extends z.AnyZodObject ? Partial<z.infer<TFilters>> : undefined;
  ordering?: NonNullable<Ordering>;
};

export type CommonData<T = unknown> = {
  result: {
    total: number;
    data?: T[];
  };
};

export type TableInfiniteDataSource<
  TData extends CommonData = CommonData,
  TFilters extends z.AnyZodObject = z.AnyZodObject,
> = {
  queryKey: string[];
  queryFn: (params: TableQueryFnParams<TFilters>) => Promise<TData>;
  /**
   * Remember to add default values to the filters schema!
   */
  filtersSchema?: TFilters;
};

export const createTableInfiniteDataSource = <TData extends CommonData, TFilters extends z.AnyZodObject>(
  options: TableInfiniteDataSource<TData, TFilters>,
): TableInfiniteDataSource<TData, TFilters> => options;
